import React, { useEffect, useState } from 'react';
import SimpleProductCard from '../Cards/SimpleProductCard';
import { ProductModel } from 'models/ProductModel';
import ProductDetailModal from '../Modals/ProductDetailModal';
import { useLocation } from 'react-router-dom';
import { Draggable } from '../Drop/Draggable';

interface ProductListProps {
  products: ProductModel[];
}

const ProductList: React.FC<ProductListProps> = ({ products }) => {
  const [open, setOpen] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState('');
  const location = useLocation()


  useEffect(() => {
    const getQueryParams = (search: string) => {
      return new URLSearchParams(search);
    };
    const searchParams = getQueryParams(location.search).get('produit')

    if (searchParams) {
      setSelectedProduct(searchParams)
      setOpen(true)
    }
  }, [location])
  

  const onClickProduct = (id:string) => {
    setSelectedProduct(id)
    setOpen(true)
  }
  
  return (
    <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      <ProductDetailModal idProduct={selectedProduct} open={open} onClose={setOpen} />
      {products.map((product, index) => (
        <Draggable key={index} id={index} product={product}>
          <SimpleProductCard
            image={product.image}
            price={product.price}
            minimum={product.minimum}
            productId={product.productId}
            productName={product.productName}
            unitFormat={product.unitFormat}
            stock={product.stock}
            onClickProduct={onClickProduct}
            taxRate={product.taxRate}
            quantity={product.quantity}
          />
        </Draggable>
      ))}
    </div>
  );
};

export default ProductList